/* eslint-disable import/prefer-default-export*/

import { SettingsPageContent } from 'styles/settings';
import colors from 'styles/colors';
import styled from 'styled-components';
import { TableContainer } from 'components/SectionTable';

export const PageContent = styled(SettingsPageContent)`
  overflow-x: auto;
`;

export const SettingsTableWrapper = styled.div`
  &:first-child {
    margin-top: 0;
  }
  margin-top: 60px;
`;

export const LightColoredText = styled.span`
  color: ${colors.gray40};
`;

export const RightAligned = styled.div`
  width: 100%;
  text-align: right;
`;

export const PriceCodeContainer = styled.div`
  display: flex;
  gap: 5px;
  max-width: min-content;

  & > *:nth-child(1) {
    width: 65%;
  }

  & > *:nth-child(2) {
    width: 35%;
  }
`;

export const TaxNumberRateContainer = styled.div`
  display: flex;
  gap: 5px;
  justify-content: space-between;

  & > *:nth-child(1) {
    width: 60%;
  }

  & > *:nth-child(2) {
    width: 35%;
  }
`;
export const CodeDescriptionContainer = styled.div`
  display: flex;
  gap: 5px;
  justify-content: space-between;

  & > *:nth-child(1) {
    width: 35%;
  }

  & > *:nth-child(2) {
    width: 60%;
  }
`;

export const TaxContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 30%;
  font-weight: 600;
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const TaxTypeContainer = styled.div`
  margin-right: 8px;
`;

export const DirectiveContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 365px;
  font-size: 14px;
  margin-bottom: 10px;
`;

export const CheckmarkContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const ChargeCatalogueTableContainer = styled(TableContainer)`
  overflow-y: scroll;
  max-height: 500px;
`;

export const CenteredColumnHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
